module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-exports"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.exportPreviewPdf();
      }
    }
  }, [_c('span', {
    staticClass: "badge-resolution"
  }, [_vm._v("HD")]), _vm._v(" " + _vm._s(_vm.$t("planobuilder.exportPreview")) + " - " + _vm._s(_vm.$t("planobuilder.highDefinition")) + "\n    ")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.exportPdf();
      }
    }
  }, [_c('span', {
    staticClass: "badge-resolution"
  }, [_vm._v("HD")]), _vm._v(" " + _vm._s(_vm.$t("planobuilder.exportPDF")) + " - " + _vm._s(_vm.$t("planobuilder.highDefinition")) + "\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.exportPreviewPdf('extreme');
      }
    }
  }, [_c('span', {
    staticClass: "badge-resolution inactive"
  }), _vm._v(" " + _vm._s(_vm.$t("planobuilder.exportPreview")) + " - " + _vm._s(_vm.$t("planobuilder.lowDefinition")) + "\n    ")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.exportPdf('extreme');
      }
    }
  }, [_c('span', {
    staticClass: "badge-resolution inactive"
  }), _vm._v(" " + _vm._s(_vm.$t("planobuilder.exportPDF")) + " - " + _vm._s(_vm.$t("planobuilder.lowDefinition")) + "\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.exportXls();
      }
    }
  }, [_c('span', {
    staticClass: "badge-resolution",
    staticStyle: {
      "background-color": "green"
    }
  }, [_vm._v("XlS")]), _vm._v(" " + _vm._s(_vm.$t("planobuilder.exportXLS")))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc7202bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/Exports.vue
// module id = 3357
// module chunks = 0